export default "/images/fe-img-1.png?596896b8c22f65accc7c5510a41ea228";